// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios';
import point_tc from '@/components/point_tc.vue';
import page_tc from '@/components/page_tc.vue';
import ticket_tc from '@/components/ticket_tc.vue';
import site from '@/components/site.vue';
import nav from '@/components/nav.vue';
import store from './store'
import { get } from '@/utils/request'
// import 'font-awesome/css/font-awesome.min.css'
Vue.prototype.$axios = axios
Vue.component('navv', nav)
Vue.component('site', site)
Vue.component('point_tc', point_tc)
Vue.component('page_tc', page_tc)
Vue.component('ticket_tc', ticket_tc)
Vue.use(ElementUI)
Vue.config.productionTip = false

Vue.prototype.get = get
Vue.prototype.web_tit = '乐行巴士-日本巴士预订订票官网，日本夜行巴士，日本昼行巴士，日本旅游巴士，日本旅行巴士'
Vue.prototype.$store = store

Vue.prototype.to_hi = function (datetime) {
  if (!datetime) {
    return ''
  }
  return datetime.substr(0, 16)
}

Vue.prototype.to_ym = function (datetime) {
  if (!datetime) {
    return ''
  }
  return datetime.substr(0, 7)
}

Vue.prototype.admin_url = 'http://api.japanbus.cn'
Vue.prototype.city_dis = function (s) {
  if (!s) {
    return ''
  }
  return s.split('(')[0].split('（')[0]
}



Vue.prototype.to_ymd = function (datetime) {
  if (!datetime) {
    return ''
  }
  return datetime.substr(0, 10)
}


function cache(k, v) {
  // console.log('dodo', v)
  if (typeof (v) == 'undefined') {
    // get

    return JSON.parse(localStorage.getItem(k));
  } else if (v == null) {
    // del
    // console.log('del')
    localStorage.removeItem(k);
  } else {
    // set
    // console.log('set', v)
    localStorage.setItem(k, JSON.stringify(v));
  }

}
if (!cache('lang_config')) {
  cache('lang_config', 'cn')
}
Vue.prototype.cache = cache

let ldata = {}
let foot = []
const start = async () => {

  if (0 && cache('lang')) {
    ldata = cache('lang')
  } else {
    await get('/lang').then((e) => {
      foot = e.foot
      ldata = e.lang
      // console.log(e)
      cache('lang', ldata)
    });

  }
  Vue.prototype.foot_adv = foot

  Vue.prototype.$lang = function (k) {
    // console.log(ldata)
    let lang = cache('lang_config')
    lang = lang ? lang : 'cn'

    try {
      return ldata[k][lang]

    } catch (err) {
      console.log(err)
      return '--'
    }

  }
  Vue.prototype.c = Vue.prototype.$lang

  Vue.prototype.clearss = function(s) {
    return s.replaceAll('&nbsp;','').replaceAll(' ', '').replaceAll('\\n', '').replaceAll('\n', '')
 
 }
  Vue.prototype.jump2 = function (url) {
    cache('jump_to', url)
    router.push({ path: '/jump/to', query: {}, replace: true })
  }
  Vue.prototype.jump = function (url, para = {}, replace = false) {

    router.push({ path: url, query: para, replace: replace })
  }
  Vue.prototype.back = function () {

    router.back()
  }

  Vue.prototype.decimal = function (v, len = 2) {
    return parseFloat(v).toFixed(len)

  }



  new Vue({
    components: { App },
    router,
    template: '<App/>'
  }).$mount('#app')


}

start()



// WEBPACK FOOTER //
// ./src/main.js